import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getProblemStatementKind, ProblemStatementKind } from '../../../catalogue/reference-datasets/hackathon-datasets.data';

export interface ReferenceDatasetCardData {
  id: string;
  title: string;
  problemStatement?: string;
  modality: string;
  volume: string;
  output: string;
  primaryMetrics: readonly string[];
  secondaryMetric: string;
}

@Component({
  selector: 'app-reference-dataset-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reference-dataset-card.component.html',
  styleUrl: './reference-dataset-card.component.scss',
})
export class ReferenceDatasetCardComponent {
  @Input({ required: true }) dataset!: ReferenceDatasetCardData;
  @Input() showSubmitModel = true;
  @Output() viewDetails = new EventEmitter<void>();
  @Output() submitModel = new EventEmitter<void>();

  get problemKind(): ProblemStatementKind {
    return getProblemStatementKind(this.dataset.problemStatement);
  }

  onViewDetails(event?: Event): void {
    event?.stopPropagation();
    this.viewDetails.emit();
  }

  onSubmitModel(event: Event): void {
    event.stopPropagation();
    this.submitModel.emit();
  }

  onHeaderKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onViewDetails();
    }
  }
}
